import { render, staticRenderFns } from "./EditGeneralKasbon.vue?vue&type=template&id=16601eca"
import script from "./EditGeneralKasbon.vue?vue&type=script&lang=js"
export * from "./EditGeneralKasbon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports